import { useState } from "react";
import { Mail } from "lucide-react";
import { isEmail, VOTE_DOMAINS } from "../lib/api";
import { toast } from "sonner";

export const EmailForm = ({ onSet, cta = "Entrar" }) => {
  const [v, setV] = useState("");
  const submit = (ev) => {
    ev.preventDefault();
    const e = v.trim().toLowerCase();
    if (!isEmail(e)) return toast("Revisa tu correo.");
    onSet(e);
  };
  return (
    <form className="idform" onSubmit={submit} noValidate>
      <input type="email" value={v} onChange={(e) => setV(e.target.value)} placeholder="tu@correo.com"
        autoComplete="email" data-testid="identity-email-input" />
      <button className="btn" type="submit" data-testid="identity-email-submit">{cta}</button>
    </form>
  );
};

export const IdentityBar = ({ email, onSet, onClear }) => (
  <div className="idbar" data-testid="identity-bar">
    <Mail size={18} className="idicon" />
    {email ? (
      <div className="idtxt">
        Participas como <b data-testid="identity-current-email">{email}</b>
        <button type="button" className="link" onClick={onClear} data-testid="identity-change-btn">Cambiar</button>
      </div>
    ) : (
      <div className="idwrap">
        <div className="idtxt">Escribe tu correo para votar o subir tu león. Un voto por correo.
          <div className="domains" data-testid="vote-domains">Pueden votar correos: {VOTE_DOMAINS.join(" · ")}</div>
        </div>
        <EmailForm onSet={onSet} />
      </div>
    )}
  </div>
);
